import React, { useState } from "react";
import { t } from "../../../../../../../utils/i18n";

const FormModal = ({
  walletName,
  url,
  caption,
  isSubmitting,
  handleInputChange,
  handleCloseModal,
  onSubmit
}) => {
  const [hasError, setHasError] = useState(false);
  const [errorMessage, setErrorMessage] =useState("");

  const submitForm = (e) => {
    const expression = /[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)?/gi;
    const regex = new RegExp(expression);

    if (!url.match(regex)) {
      e.preventDefault();
      setErrorMessage(t("p2p.wallets.invalid_url"))
      setHasError(true);
      return;
    }

    if (caption === "") {
      e.preventDefault();
      setErrorMessage(t("p2p.wallets.need_caption"))
      setHasError(true);
      return;
    }
    setErrorMessage("")
    setHasError(false);
    onSubmit(e);
  };

  return (
    <div className="modal d-flex align-items-center justify-content-center" tabIndex="-1" role="dialog">
      <div className="modal-dialog modal-lg" role="document">
        <div className="modal-content" style={{ minWidth: "350px" }}>
          <button
            type="button"
            className="close-addaccount"
            data-dismiss="modal"
            aria-label={t("p2p.common.close")}
            onClick={e => handleCloseModal(e)}
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <div>
            <h5 className="modal-title-addaccount" id="exampleModalLongTitle">
              {t("p2p.wallets.add")}
            </h5>
          </div>
          <div className="modal-body">
          {hasError && (
              <div className="createtrade-error">
                {errorMessage}
              </div>
            )}
            <form>
              <div className="form-group">
                <label htmlFor="">{t("p2p.wallets.url")}</label>
                <input
                  className="form-control"
                  placeholder={t("p2p.wallets.url_placeholder")}
                  value={url}
                  onChange={e => handleInputChange(e, "url")}
                />
              </div>
              <div className="form-group">
                <label htmlFor="">{t("p2p.wallets.caption")}</label>
                <input
                  className="form-control"
                  placeholder={t("p2p.wallets.caption_placeholder")}
                  value={caption}
                  onChange={e => handleInputChange(e, "caption")}
                />
              </div>
              <div className="createoffermodal-addaccount-btns-cont">
                <button
                  type="button"
                  className="createoffer-modal-addaccount-cancelbutton"
                  data-dismiss="modal"
                  onClick={e => handleCloseModal(e)}
                >
                  {t("p2p.common.cancel")}
                </button>
                <button
                  type="submit"
                  className="createoffer-modal-addaccount-button"
                  disabled={isSubmitting}
                  onClick={e => submitForm(e)}
                >
                  {isSubmitting ? t("p2p.common.submitting") : t("p2p.common.add")}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FormModal;
